export default __webpack_public_path__ + "static/media/brown.27ebc3be.png";